import type { IDiscountTileV3Resources } from "@Components/discount-tile/discount-tile-v3.Resources";

export const DiscountTileV3ResourcesEn: IDiscountTileV3Resources = {
    flyerLabel: "New Flyer",
    discountType: {
        Dedicated: "Discount",
        Promotion: "Discount",
        Sale: "SALE",
        New: "Novelty",
        Event: "Event",
        Flyer: "Flyer",
    },
    accessibility: {
        brand: "Store",
    },
};
